import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import { useLogout } from 'features/auth';
export default function BlockedScreen({ reason }) {
    const { t } = useTranslation();
    const logout = useLogout();
    const message = reason === 'deleted'
        ? t('auth_deleted_user')
        : reason === 'inactive'
            ? t('auth_inactive_user')
            : reason === 'unsupported-account'
                ? t('auth_unsupported_account')
                : t('auth_exchange_failed');
    return (_jsx("div", { className: "flex min-h-screen items-center justify-center bg-[#f9fafb] px-4 py-8 text-[#0a0a0a]", children: _jsxs("div", { className: "flex max-w-160 flex-col items-center gap-4 border-2 border-[#fecaca] bg-white p-8.5 text-center", children: [_jsx("h2", { className: "m-0 text-[24px] font-semibold leading-8", children: message }), _jsx("p", { className: "m-0 text-[16px] leading-6 text-[#4a5565]", children: t('auth_access_blocked_help') }), _jsx("button", { onClick: () => void logout.mutateAsync(), disabled: logout.isPending, className: "inline-flex min-h-10.5 items-center justify-center border border-[#99a1af] bg-white px-4 text-[16px] leading-6 text-[#0a0a0a] disabled:opacity-50", type: "button", children: t('auth_sign_out') })] }) }));
}
